module.exports = __webpack_public_path__ + "static/media/ceilings-003.88f64374.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gallery/ceilings-003.jpg
// module id = 91
// module chunks = 0